
import { throwError as observableThrowError } from 'rxjs';
import { Injectable, APP_INITIALIZER, Inject, Injector, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { AppConstants } from './app.constants';

export const WINDOW = new InjectionToken('window',
  {
    providedIn: 'root',
    factory: () => window
  }
);

@Injectable()
export class AppConfig {

  public config: Object;
  public env: string;

  constructor(public http: HttpClient, @Inject(WINDOW) private window: Window) { }

  load() {
    return new Promise((resolve, reject) => {

      this.http.get<string>('./assets/config/env.json', { headers: new HttpHeaders({ 'No-Auth': 'True' }) })
        .subscribe((data: any) => {
          this.env = data;
          const congfigfile = './assets/config/' + data.env + '.json';
          this.http.get<any>(congfigfile, { headers: new HttpHeaders({ 'No-Auth': 'True' }) })
            .subscribe((configs) => {
              this.config = configs;
              resolve(true);
            },
              (err) => {
                return observableThrowError(err || data.env + '.json error');
              });
        },
          (err: any) => {
            return observableThrowError(err || 'env.json error');
          });

    });
  }

  public getConfig(key: any) {
    const port = this.window.location.protocol.includes(AppConstants.HTTPS_PROTOCOL)
      ? this.config[AppConstants.SERVER_SSL_PORT_STRING]
      : this.config[AppConstants.SERVER_PORT_STRING];

    const pathname = (key === 'api' ? `${key}/` : '');

    return `${ this.window.location.protocol }//${ this.window.location.hostname }:${ port }/${ pathname }`;
  }

}

export function ConfigFactory(injector: Injector) {
  return () => injector.get(AppConfig).load();
}

export function init() {
  return {
    provide: APP_INITIALIZER,
    useFactory: ConfigFactory,
    deps: [Injector],
    multi: true
  };
}

const ConfigModule = {
  init
};

export { ConfigModule };
